<!--成品出库明细账-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form class="search-form-outbound" @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="orderType"
          :dropdown-match-select-width="false"
          v-model="queryParams.orderType"
          selectType="selectMultiple"
          requestApi="/inv/invOnhandQuantities/findOrderTypeList"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
          sourseField="res"
        />
        <global-select
          v-decorator="['orgCode', { rules: [{ required: true }] }]"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="orgCode"
          :value.sync="queryParams.orgCode"
          selectType="select"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <a-range-picker
          slot="deliveryDate"
          v-model="currentDeliveryDateObj"
          @change="changePriceRangeDate"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiWmsOutboundDetailExport" ref="download" />
        <a-button
          type="primary"
          @click="handleExport"
        >导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="id"
                      :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiWmsOutboundDetailListw3, apiWmsOutboundDetailExport } from '@/api/report/inventory-outbound-details'
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import moment from 'moment'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Finished-product-outbound-details', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      currentDeliveryDateObj: [],
      apiWmsOutboundDetailExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiWmsOutboundDetailListw3, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        wipEntityName: undefined,
        orgCode: undefined,
        exitOrderNumber: undefined,
        orderNumber: undefined,
        pickOrderNumber: undefined,
        itemCode: undefined,
        insideLotName: undefined,
        lotName: undefined,
        deliveryDateFrom: undefined,
        deliveryDateTo: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '工单号', decorator: ['wipEntityName'], type: 'input' },
        { label: '组织编码', decorator: ['orgCode'], type: 'orgCode' },
        { label: '出库单号', decorator: ['exitOrderNumber'], type: 'input' },
        { label: '外部单号', decorator: ['orderNumber'], type: 'input' },
        { label: '拣货单号', decorator: ['pickOrderNumber'], type: 'input' },
        { label: '物料编码', decorator: ['itemCode'], type: 'input' },
        { label: '内部批次', decorator: ['insideLotName'], type: 'input' },
        { label: '生产批次', decorator: ['lotName'], type: 'input' },
        { label: '配送时间', type: 'deliveryDate', decorator: ['deliveryDate'] },
        { label: 'YL色差/CP库存层级', decorator: ['ylcp'], type: 'input' }
      ],
      // 表格字段
      columns: [
        { title: '工单号', dataIndex: 'wipEntityName', align: 'center', width: 180, ellipsis: true },
        { title: '组织编码', dataIndex: 'orgCode', align: 'center', width: 120, ellipsis: true },
        { title: '组织名称', dataIndex: 'organizationName', align: 'center', width: 180, ellipsis: true },
        { title: '子库代码', dataIndex: 'sublibraryCode', align: 'center', width: 120, ellipsis: true },
        { title: '出库单号', dataIndex: 'exitOrderNumber', align: 'center', width: 140, ellipsis: true },
        { title: '单据类型', dataIndex: 'orderType', align: 'center', width: 100, ellipsis: true },
        { title: '出库单行号', dataIndex: 'exitOrderLineNum', align: 'center', width: 120, ellipsis: true },
        { title: '外部单号', dataIndex: 'orderNumber', align: 'center', width: 150, ellipsis: true },
        { title: '外部单行号', dataIndex: 'orderNumberLineNum', align: 'center', width: 120, ellipsis: true },
        { title: '拣货单号', dataIndex: 'pickOrderNumber', align: 'center', width: 150, ellipsis: true },
        { title: '配送单号', dataIndex: 'deliveryOrderNumber', align: 'center', width: 150, ellipsis: true },
        { title: '叫料组织', dataIndex: 'callOrganizationCode', align: 'center', width: 100, ellipsis: true },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 150, ellipsis: true },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 120, ellipsis: true },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 180, ellipsis: true },
        { title: '货品分类', dataIndex: 'goodsType', align: 'center', width: 150, ellipsis: true },
        { title: '需求数量', dataIndex: 'demandQty', align: 'center', width: 120, ellipsis: true },
        { title: '配送数量', dataIndex: 'deliveryQty', align: 'center', width: 120, ellipsis: true },
        { title: '单位', dataIndex: 'unit', align: 'center', width: 90, ellipsis: true },
        { title: '拣货库位', dataIndex: 'pickLocation', align: 'center', width: 120, ellipsis: true },
        { title: '流水号', dataIndex: 'serialNumber', align: 'center', width: 150, ellipsis: true },
        { title: '内部批次', dataIndex: 'insideLotName', align: 'center', width: 150, ellipsis: true },
        { title: '生产批次', dataIndex: 'lotName', align: 'center', width: 180, ellipsis: true },
        { title: '供应商编码', dataIndex: 'supplierCode', align: 'center', width: 150, ellipsis: true },
        { title: '供应商名称', dataIndex: 'supplierName', align: 'center', width: 200, ellipsis: true },
        { title: '配送人', dataIndex: 'deliveryPerson', align: 'center', width: 150, ellipsis: true },
        { title: '配送时间', dataIndex: 'deliveryDate', align: 'center', width: 150, ellipsis: true, scopedSlots: { customRender: 'dateFormat' } },
        { title: 'YL色差/CP库存层级', dataIndex: 'ylcp', align: 'center', width: 150, ellipsis: true }
      ]
    }
  },
  created() {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache(
        'refSearchForm',
        'orgCode',
        {
          currentDeliveryDateObj: ['deliveryDateFrom', 'deliveryDateTo']
        },
        false
      )
    } else {
      this.queryParams.deliveryDateFrom = moment().subtract(30, 'days').format('YYYY-MM-DD')
      this.queryParams.deliveryDateTo = moment().format('YYYY-MM-DD')
      this.currentDeliveryDateObj = [moment().subtract(30, 'days'), moment()]
    }
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 选择时间
    changePriceRangeDate (dateArr, dateStrArr) {
      if (dateStrArr.length > 0) {
        this.queryParams.deliveryDateFrom = dateStrArr[0]
        this.queryParams.deliveryDateTo = dateStrArr[1]
      } else {
        this.queryParams.deliveryDateFrom = undefined
        this.queryParams.deliveryDateTo = undefined
      }
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      if (this.queryParams?.orgCode) { params.orgCode = this.queryParams.orgCode }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        wipEntityName: undefined,
        orgCode: this.$refs.dataTable.searchParams.orgCode,
        exitOrderNumber: undefined,
        orderNumber: undefined,
        pickOrderNumber: undefined,
        itemCode: undefined,
        insideLotName: undefined,
        lotName: undefined,
        deliveryDateFrom: undefined,
        deliveryDateTo: undefined
      }
      this.currentDeliveryDateObj = [];
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
/deep/.search-form-outbound .ant-col:nth-last-child(2) {
  .ant-form-item{
    .ant-form-item-label{
      width: 160px !important;
    }
    .ant-form-item-control-wrapper{
      max-width: 230px !important;
    }
  }
}
</style>
